import { getIsDataWorkerFaulted, getDataWorkerFault } from './isDataWorkerFaulted';

let fault: Error | undefined;
const callbacks = new Set<(e: Error | undefined) => void>();

export function getOfflineDataFault(): Error | undefined {
    return fault || getDataWorkerFault();
}

export function getIsOfflineDataFaulted(): boolean {
    return !!fault || getIsDataWorkerFaulted();
}

type OfflineFaultState = 'Faulted' | 'Healthy';
export function getOfflineFaultState(): OfflineFaultState {
    return fault ? 'Faulted' : 'Healthy';
}

let offlineFaultOrDisabledReason: string | undefined;
export function setOfflineFaultOrDisabledReason(r: string): void {
    offlineFaultOrDisabledReason = r;
}

export function getOfflineFaultOrDisabledState(): string {
    return offlineFaultOrDisabledReason || 'Enabled';
}

export function setIsOfflineDataFaulted(e: Error | undefined): void {
    fault = e;
    for (const cb of callbacks) {
        cb(e);
    }
}

/**
 * Register for offline data fault changes. Returns a function that removes the callback.
 */
export function registerOfflineDataFaultCallback(cb: (e: Error | undefined) => void): () => void {
    callbacks.add(cb);
    return () => {
        callbacks.delete(cb);
    };
}
